import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signInWithEmailLink, isSignInWithEmailLink } from 'firebase/auth';
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { AlertCircle, CheckCircle2 } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "./ui/alert";
import { Progress } from "./ui/progress";
import { useAuth } from "../context/AuthContext";

export default function EmailLinkVerify() {
  const navigate = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState('verifying');
  const { currentUser } = useAuth();

  useEffect(() => {
    const verifyEmailLink = async () => {
      const email = window.localStorage.getItem('emailForSignIn');
      
      if (isSignInWithEmailLink(auth, window.location.href) && email) {
        try {
          const result = await signInWithEmailLink(auth, email, window.location.href);
          window.localStorage.removeItem('emailForSignIn');
          
          // Check if user is new
          if (result.additionalUserInfo?.isNewUser) {
            // Will be redirected to complete profile after auth state updates
            setVerificationStatus('success');
          } else {
            setVerificationStatus('success');
          }
        } catch (error) {
          console.error('Error signing in with email link:', error);
          setVerificationStatus('error');
        }
      } else {
        setVerificationStatus('invalid');
        setTimeout(() => navigate('/login'), 3000);
      }
    };
    verifyEmailLink();
  }, [navigate]);

  useEffect(() => {
    if (verificationStatus === 'success' && currentUser) {      
        navigate('/');
    }
  }, [verificationStatus, currentUser, navigate]);

  const renderContent = () => {
    switch (verificationStatus) {
      case 'verifying':
        return (
          <div className="flex items-center justify-center">
            <Progress className="mr-2 h-4 w-4" />
            <p>Verifying your email link...</p>
          </div>
        );
      case 'success':
        return (
          <Alert variant="default">
            <CheckCircle2 className="h-4 w-4" />
            <AlertTitle>Success</AlertTitle>
            <AlertDescription>
              You have successfully signed in. Redirecting...
            </AlertDescription>
          </Alert>
        );
      case 'error':
        return (
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Error</AlertTitle>
            <AlertDescription>
              Failed to sign in. Please ensure you are using the right email address and try again.
            </AlertDescription>
          </Alert>
        );
      case 'invalid':
        return (
          <Alert variant="destructive">
            <AlertCircle className="h-4 w-4" />
            <AlertTitle>Invalid Link</AlertTitle>
            <AlertDescription>
              The sign-in link is invalid or has expired. Redirecting to sign-in page...
            </AlertDescription>
          </Alert>
        );
      default:
        return null;
    }
  };

  return (
    <Card className="w-[350px] mx-auto mt-10">
      <CardHeader>
        <CardTitle>Email Verification</CardTitle>
      </CardHeader>
      <CardContent>{renderContent()}</CardContent>
    </Card>
  );
}